export const selector = ({ appConfiguration, places, checkoutCorpo }) => ({
  phoneTypes: appConfiguration.sharedConfig.phoneTypes,
  localize: appConfiguration.localize,
  corpoData: checkoutCorpo.requestData,
  rooms: checkoutCorpo.selectedAvailability.hotelInformation.rooms,
  places
});
